@if (label) {
  <app-control-header
    class="radio-group-label"
    [label]="label"
    [isLabelBold]="isLabelBold"
    [labelWithColon]="labelWithColon"
    [infoTooltip]="infoTooltip"
    [infoTooltipClass]="infoTooltipClass"
    [infoTooltipPlacement]="infoTooltipPlacement"
    [labelParamsObj]="labelParamsObj"
    [sublabel]="sublabel"
    [index]="index"
    [required]="required"
  ></app-control-header>
}

<div
  class="buttons-container flex"
  [ngClass]="{
    'flex-row': buttonsPosition === 'horizontal',
    'flex-col gap-y-3': buttonsPosition === 'vertical',
    'gap-x-7': buttonsPosition === 'horizontal' && customGap === 'default',
    'gap-x-4': buttonsPosition === 'horizontal' && customGap === '16px',
  }"
>
  @for (radioBtn of buttons; track i; let i = $index) {
    <div
      [ngClass]="{
        'rounded-md p-5 border border-solid border-transparent hover:bg-navy-10 flex flex-col gap-y-3 cursor-pointer':
          extendedMode,
        'bg-navy-10 border-navy-50': extendedMode && checkValue(radioBtn),
      }"
      [ngbTooltip]="getButtonTooltip(radioBtn)"
      [placement]="buttonTooltipPlacement || ['top']"
      [tooltipClass]="buttonTooltipClass"
      (click)="extendedMode && !isDisabled && setValue(i)"
    >
      <app-radio-button
        [attr.data-test-id]="radioBtn.id"
        [ngClass]="{
          'font-bold text-base': extendedMode,
        }"
        [hideButton]="hideButton"
        [size]="buttonsSize"
        [value]="checkValue(radioBtn)"
        [id]="radioBtn.id"
        [disabled]="isRadioButtonDisabled(radioBtn)"
        [infoIconTranslationKey]="radioBtn?.infoIconTranslationKey"
        (toggled)="!isDisabled && setValue(i)"
      >
        @if (radioBtn.icon) {
          <svg-icon
            class="radio-button-icon"
            [ngClass]="radioBtn.icon"
            [class.fill]="radioBtn.iconChangeColorMode"
            [src]="radioBtn.icon"
          ></svg-icon>
        }

        <ng-container
          *ngTemplateOutlet="
            isButtonLableTemplate(radioBtn.label) ? getButtonLabelAsTemplate(radioBtn) : spanLabel;
            context: { radioBtn: radioBtn }
          "
        ></ng-container>
      </app-radio-button>

      @if (radioBtn?.bigIcon) {
        <svg-icon [src]="radioBtn.bigIcon" [ngClass]="{ 'opacity-50': isRadioButtonDisabled(radioBtn) }"></svg-icon>
      }
    </div>
  }
</div>

@if (noteTranslationKey && noteTranslationKey()) {
  <div class="note">
    <ng-container>{{ noteTranslationKey() | translate }}</ng-container>
  </div>
}

@if (dynamicNoteFactory && dynamicNoteFactory(value)) {
  <ng-container *ngTemplateOutlet="dynamicNoteFactory(value)"></ng-container>
}

<ng-template #spanLabel let-radioBtn="radioBtn">
  @if (!radioBtn?.comingSoon) {
    <span class="radio-button-label">
      {{ radioBtn.label | translate: radioBtn.labelTranslationParams }}
    </span>
  }

  @if (radioBtn?.comingSoon) {
    <span>
      {{ radioBtn.label | translate: radioBtn.labelTranslationParams }}
    </span>
    <span>({{ 'comingSoon.title' | translate }})</span>
  }
</ng-template>
